import { SortIcon } from "components/Table_SortColumnIcon"
import { getFormattedTime } from "utils"

const oneTimeDeepLinkListColumns = () => {
  return [
    {
      text: "id",
      dataField: "id",
      sort: true,
      hidden: true,
      formatter: (cellContent, item) => <>{item.id}</>,
    },
    {
      text: "Deeplink",
      dataField: "word",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, item) => <>{item?.word}</>,
    },
    {
      text: "Created At",
      dataField: "created_at",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, item) => (
        <>
          {item?.created_at?.date
            ? getFormattedTime(
                item?.created_at?.date,
                item?.created_at?.timezone
              )
            : "-"}
        </>
      ),
    },
    {
      text: "Batch ID",
      dataField: "event_code_batch_id",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, item) => <>{item?.event_code_batch_id}</>,
    },
    {
      text: "Used",
      dataField: "used",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, item) => <>{item.used === 0 ? "No" : "Yes"}</>,
    },
    {
      text: "Used At",
      dataField: "date_used",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, item) => (
        <>
          {item?.date_used?.date
            ? getFormattedTime(item?.date_used?.date, item?.date_used?.timezone)
            : ""}
        </>
      ),
    },
    {
      text: "Used by",
      dataField: "users",
      formatter: (cellContent, item) => (
        <>
          {!!item?.users && item?.users?.length > 0
            ? `${item?.users[0]?.first_name} ${item?.users[0]?.last_name}`
            : ""}
        </>
      ),
    },
  ]
}

export default oneTimeDeepLinkListColumns
